import {
  Rewrite,
  StartsWith,
  buildGetServerSideProps,
} from '@cinch-nx/landing/feature-sitemap'
import { traceFunction } from '@core/datadog-server'

/**
 * the paths to check on storyblok
 */
const START_PATHS: StartsWith[] = [
  'seo-pages/car-finance',
  'seo-pages/car-inspection/index',
  'seo-pages/car-inspection/sub-pages',
  'seo-pages/electric-cars',
  'jargon',
  'policies',
]

/**
 * if the path starts with these, they are invalid and won't be linked
 */
const EXCLUDED_PATH_PREFIXES: string[] = []

/**
 * a list of rules to rewrite paths
 */
const REWRITES: Rewrite[] = [
  ['/seo-pages/', '/'],
  ['/sub-pages/', '/'],
  ['/index', '/'],
]

/**
 * Extra paths to be included AFTER exclusion and rewrites.
 */
const EXTRA_PATHS: string[] = []

export const getServerSideProps = traceFunction(
  'sitemap.getServerSideProps',
  buildGetServerSideProps(
    START_PATHS,
    REWRITES,
    EXCLUDED_PATH_PREFIXES,
    EXTRA_PATHS,
  ),
)

export { default } from '@cinch-nx/landing/feature-sitemap'
